module.exports = __webpack_public_path__ + "static/media/oleg_severe_left.28840b69.png";